import React from "react";
import AppModal from "./AppModal";
const SuccessICon = require("../../assets/images/success-icon.svg");
const ErrorICon = require("../../assets/images/error-icon.svg");

const AppModalAlertMessage = ({ message, setMessage }) => {
	const isOpen = message.error !== null || message.success !== null;
	const onRequestClose = () => setMessage({ success: null, error: null });
	const iconStyles = { width: 62, height: 62 };

	return (
		<AppModal
			isDialogBox
			isOpen={isOpen}
			onRequestClose={onRequestClose}
			prependContent={
				<div className="center pt-3">
					{message.error && <img src={ErrorICon} style={iconStyles} />}
					{message.success && <img src={SuccessICon} style={iconStyles} />}
				</div>
			}
			modalHeader={
				<h5 className="modal-title">
					{message.error && "Error Occurred"}
					{message.success && "Successfully"}
				</h5>
			}
			modalFooter={
				<div className="btn-inline">
					<a className="btn" onClick={onRequestClose}>
						CLOSE
					</a>
				</div>
			}
		>
			{message.error && message.error}
			{message.success && message.success}
		</AppModal>
	);
};

AppModalAlertMessage.defaultProps = {
	message: { error: null, success: null },
};

export default AppModalAlertMessage;
